const actionTypes = {
  common: {
    CHANGE_LOADING: 'CHANGE_LOADING',
    CHANGE_CURRENT_ID_STATE: 'CHANGE_CURRENT_ID_STATE',
    CHANGE_BREADCRUMB: 'CHANGE_BREADCRUMB',
    CHANGE_CONFIG: 'CHANGE_CONFIG',
    CHANGE_SHOULD_SHOW_STATEMENT: 'CHANGE_SHOULD_SHOW_STATEMENT',
    CHANGE_SCROLL_BAR: 'CHANGE_SCROLL_BAR',
    CHANGE_PROJECT_INFO: 'CHANGE_PROJECT_INFO',
    CHANGE_PROJECT_INFO_LOADING: 'CHANGE_PROJECT_INFO_LOADING',
    TOGGLE_REPORT_ISSUE_MODAL: 'TOGGLE_REPORT_ISSUE_MODAL',
    CHANGE_REPORT_ISSUE_VALUES: 'CHANGE_REPORT_ISSUE_VALUES',
    CHANGE_ROUTES: 'CHANGE_ROUTES',
    CHANGE_SPN_ID: 'CHANGE_SPN_ID',
    CHANGE_PROJECT_INSTANCE: 'CHANGE_PROJECT_INSTANCE',
    CHANGE_SETTING_COMPANY_INSTANCE: 'CHANGE_SETTING_COMPANY_INSTANCE',
    SHOW_BANNER: 'SHOW_BANNER',
    CLOSE_BANNER: 'CLOSE_BANNER',
    CHANGE_URL_MAP: 'CHANGE_URL_MAP',
    CHANGE_SYSTEM_THEME: 'CHANGE_SYSTEM_THEME',
    CHANGE_SYSTEM_THEME_LOADING: 'CHANGE_SYSTEM_THEME_LOADING',
    SET_EMAIL_VERIFY_MODAL_REF: 'SET_EMAIL_VERIFY_MODAL_REF',
  },
  login: {
    SAVE_USER_INFO: 'SAVE_USER_INFO',
    DELETE_USER_INFO: 'DELETE_USER_INFO',
    ACCEPT_TERMS: 'ACCEPT_TERMS',
    ACCEPT_NEW_TERMS: 'ACCEPT_NEW_TERMS',
    UPDATE_USER_INFO: 'UPDATE_USER_INFO',
    CHANGE_SESSION_TIMEOUT: 'CHANGE_SESSION_TIMEOUT',
    SET_ACTIVE_SESSIONS: 'SET_ACTIVE_SESSIONS',
    CLEAR_ACTIVE_SESSIONS: 'CLEAR_ACTIVE_SESSIONS',
  },
  projects: {
    CHANGE_PROJECTS_LIST: 'CHANGE_PROJECTS_LIST',
    CHANGE_PINNED_PROJECTS: 'CHANGE_PINNED_PROJECTS',
    SAVE_QUERY_COMPANY_NAME: 'SAVE_QUERY_COMPANY_NAME',
    CLEAR_COMPANY_NAME: 'CLEAR_COMPANY_NAME',
    SAVE_PROJECTS_STATE: 'SAVE_PROJECTS_STATE',
    CHANGE_QUERY_COMPANY_LOADING: 'CHANGE_QUERY_COMPANY_LOADING',
    CREATE_PROJECT_DISABLED_HANDLER: 'CREATE_PROJECT_DISABLED_HANDLER',
    CHANGE_QUERY_NAMES_LOADING: 'CHANGE_QUERY_NAMES_LOADING',
    SAVE_PROJECT_DETAIL: 'SAVE_PROJECT_DETAIL',
    CHANGE_USER_PREFERENCE: 'CHANGE_USER_PREFERENCE',
    CHANGE_TEAMS_NAMES: 'CHANGE_TEAMS_NAMES',
    SAVE_TEAMS_NAMES: 'SAVE_TEAMS_NAMES',
    CHANGE_MEMBERS_DATA: 'CHANGE_MEMBERS_DATA',
    CHANGE_TEAMS_DETAIL: 'CHANGE_TEAMS_DETAIL',
    CHANGE_CLIENTS_DETAIL: 'CHANGE_CLIENTS_DETAIL',
    CHANGE_GROUPS_DETAIL: 'CHANGE_GROUPS_DETAIL',
    SAVE_DATA: 'SAVE_DATA',
    SETTING_PROJECT_DATA: 'SETTING_PROJECT_DATA',
    SAVE_USER_PERMISSION: 'SAVE_USER_PERMISSION',
    CHANGE_ARCHIVE_LIST: 'CHANGE_ARCHIVE_LIST',
    MAIN_PAGE_DROP_DOWN_HANDLER: 'MAIN_PAGE_DROP_DOWN_HANDLER',
    DUNS_NUMBER_LIST_HANDLER: 'DUNS_NUMBER_LIST_HANDLER',
    CLEAR_TEAMS_DATA: 'CLEAR_TEAMS_DATA',
    SAVE_MODULE_STATUS: 'SAVE_MODULE_STATUS',
    SAVE_CUSTOMIZED_MODULES: 'SAVE_CUSTOMIZED_MODULES',
    SAVE_ACCESSIBLE_MODULES: 'SAVE_ACCESSIBLE_MODULES',
    SAVE_ORIGIN_ACCESSIBLE_MODULES: 'SAVE_ORIGIN_ACCESSIBLE_MODULES',
    SAVE_PERMISSION_BUNDLE_PROJECT_ID: 'SAVE_PERMISSION_BUNDLE_PROJECT_ID',
    SAVE_PROJECT_STATUS: 'SAVE_PROJECT_STATUS',
    CHANGE_INTEGRATION_NAVIGATOR_LOADING:
      'CHANGE_INTEGRATION_NAVIGATOR_LOADING',
    CHANGE_PERMISSION_LOADED: 'CHANGE_PERMISSION_LOADED',
    CHANGE_PERMISSION_LOADING: 'CHANGE_PERMISSION_LOADING',
    CLEAR_PROJECT_DETAIL: 'CLEAR_PROJECT_DETAIL',
    CHANGE_WIDGET: 'CHANGE_WIDGET',
    DELETE_WIDGET: 'DELETE_WIDGET',
    CLEAR_WIDGETS: 'CLEAR_WIDGETS',
    RESET_PROJECT_DATA: 'resetProjectData',
    CHANGE_THEME: 'CHANGE_THEME',
  },
  analysis: {
    CHANGE_STOCKCHART_DATA: 'CHANGE_STOCKCHART_DATA',
    CHANGE_MARKETCAP_DATA: 'CHANGE_MARKETCAP_DATA',
    CHANGE_ANALYSIS_INSIGHT_DATA: 'CHANGE_ANALYSIS_INSIGHT_DATA',
    CHANGE_TOTAL_REVENUE_DATA: 'CHANGE_TOTAL_REVENUE_DATA',
    CHANGE_DEAL_COMPLEXITY: 'CHANGE_DEAL_COMPLEXITY',
    SET_SHOW_KEY_CONTACTS: 'SET_SHOW_KEY_CONTACTS',
    SAVE_KEY_CONTACTS_DATA: 'SAVE_KEY_CONTACTS_DATA',
    CHANGE_COMPANY_HISTORY_DATA: 'CHANGE_COMPANY_HISTORY_DATA',
    CHANGE_FORCEUPDATE_PROJECT_IDS: 'CHANGE_FORCEUPDATE_PROJECT_IDS',
    TOGGLE_LE_UPLOAD_MODAL: 'TOGGLE_LE_UPLOAD_MODAL',
    CHANGE_SHOULD_SHOW_OFFICE: 'CHANGE_SHOULD_SHOW_OFFICE',
  },
  insights: {
    CHANGE_GD_PRINCIPLE_DATA: 'CHANGE_GD_PRINCIPLE_DATA',
    CHANGE_VALUE_DRIVER_MANAGE_DATA: 'CHANGE_VALUE_DRIVER_MANAGE_DATA',
  },
  questionnaires: {
    CHANGE_QUESTIONS: 'CHANGE_QUESTIONS',
    CLEAR_QUESTIONS: 'CLEAR_QUESTIONS',
    QUESTIONNAIRE_ACCESS_HANDLER: 'QUESTIONNAIRE_ACCESS_HANDLER',
    CHANGE_COMPLEXITY_MODE: 'CHANGE_COMPLEXITY_MODE',
    CHANGE_SIDEBAR_SECTION_LEVEL: 'CHANGE_SIDEBAR_SECTION_LEVEL',
    CANCEL_QUESTION_EDIT: 'CANCEL_QUESTION_EDIT',
  },
  systemSettings: {
    CHANGE_NAVIGATION: 'CHANGE_NAVIGATION',
    CHANGE_VALUE_DRIVER: 'CHANGE_VALUE_DRIVER',
    CHANGE_GUIDING_PRINCIPLE: 'CHANGE_GUIDING_PRINCIPLE',
    CHANGE_WHITE_LIST: 'CHANGE_WHITE_LIST',
    CHANGE_WHITE_LIST_USER: 'CHANGE_WHITE_LIST_USER',
    REMOVE_WHITE_LIST_USER: 'REMOVE_WHITE_LIST_USER',
    CHANGE_FETCHING_VALUE_DRIVER_TMPLT: 'CHANGE_FETCHING_VALUE_DRIVER_TMPLT',
  },
  powerBIRefresh: {
    WEBSOCKET_MESSAGE_RECEIVED: 'WEBSOCKET_MESSAGE_RECEIVED',
    TRIGGER_BUTTON_REQUEST: 'TRIGGER_BUTTON_REQUEST',
    TRIGGER_BUTTON_SUCCESS: 'TRIGGER_BUTTON_SUCCESS',
    TRIGGER_BUTTON_FAILURE: 'TRIGGER_BUTTON_FAILURE',
    STATE_RESET: 'STATE_RESET',
  },
};

export { actionTypes };
